import { EJobType, JobType } from "@project/shared-types";
import { JobReviewViewer } from "./JobReviewViewer";
import { JobSubViewer } from "./JobSubViewer";

export const getViewer = (job_type: JobType) => {
  if (job_type === EJobType.REVIEW) {
    return JobReviewViewer;
  }
  return JobSubViewer;
};
